module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_base.1001.jpg.dxt.1108a6fa.ktx";